import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const ReturnOrderFormContainerSX:SxProps = {
    my:2,
    p:3,
    '& input.validation-failed ~ fieldset':{
        border:'1px solid red',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
    },
    '& .content-recomnedation-widget, .content-recomnedation-widget div':{
        fontSize:16
    },
    '& .content-recomnedation-widget a':{
        textDecoration:'underline'
    }
}

export const AddressCheckFormSX:SxProps = {
    '& .MuiGrid-container':{
        py:1.5
    }
}

export const displayProductDataGridSX:SxProps = {
    '& .MuiDataGrid-cell':{
        display:'flex',
        alignItems:'center',
        py:1
    }
}

export const SelectReasonFormSX = AddressCheckFormSX;

export const ReturnOrderErrorPageFormSX:SxProps = {
    flexDirection:globalBreak({mobile:'column',desktop:'row'}),
    '& .return-error-page-header-text .content-recomnedation-widget':{
        fontSize:24
    }
}

export const returnErrorImgSX:SxProps = {
    p:globalBreak({mobile:5, desktop:0})
}